import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import CmsFilteredPromotions from '../../../../components/cms-filtered-promotions/cms-filtered-promotions';

import { GET_PROMOTIONS } from '../../graphql/store-detail-queries';

import './store-promos.scss';

function StorePromos() {
  const { data } = useQuery(GET_PROMOTIONS);

  const { contentSlots } = data?.cms?.page || {};
  let promoData = null;

  if (contentSlots) {
    for (let section of contentSlots.reverse()) {
      const found = section?.cmsComponents?.find(
        c => c.__typename === 'CmsFilteredPromotionsComponent'
      );
      if (found) promoData = found;
    }
  }

  return promoData ? (
    <div styleName="promos">
      <CmsFilteredPromotions {...promoData} />
    </div>
  ) : null;
}

export default StorePromos;
